import { TranslationKeys } from './en';

export const ru: TranslationKeys = {
  // Common
  common: {
    loading: 'Загрузка...',
    error: 'Ошибка',
    cancel: 'Отмена',
    save: 'Сохранить',
    continue: 'Продолжить',
    back: 'Назад',
    close: 'Закрыть',
    select: 'Выбрать',
    required: 'Обязательно',
    appTitle: 'Fire and Ice',
    goBack: 'Вернуться назад',
    goHome: 'На главную',
    success: 'Успех',
    inTallinn: 'в Таллинне',
  },

  // Page Titles
  pageTitles: {
    home: 'Велнес-студия нового поколения',
    book: 'Забронировать сеанс',
    pricing: 'Цены',
    promotions: 'Акции',
    contact: 'Контакты',
    checkBalance: 'Проверить баланс подарочной карты',
    gallery: 'Галерея',
  },

  invitation: {
    accept: 'Принять приглашение',
    decline: 'Отклонить приглашение',
    accepted: 'Приглашение принято! Ваши аккаунты теперь связаны.',
    declined: 'Приглашение отклонено.',
    processing: 'Обработка вашего ответа...',
    error: 'Это приглашение недействительно, устарело или аккаунты уже связаны.',
  },

  // Navigation
  nav: {
    title: 'Fire & Ice',
    home: 'Главная',
    bookSession: 'Забронировать сеанс',
    myAccount: 'Мой аккаунт',
    login: 'Войти',
    logout: 'Выйти',
    signUp: 'Регистрация',
    giftCards: 'Подарочные карты',
    sessionBundles: 'Комплексы сессий и подписки',
    services: 'Услуги',
    packages: 'Пакеты',
    scienceStudies: 'Наука',
    sessionBundlesShort: 'Комплексы сессий',
    pricing: 'Цены',
    memberships: 'Членство',
    promotions: 'Акции',
    about: 'Контакты',
    gallery: 'Галерея',
  },

  promotions: 'Акции',

  about: {
    title: 'Контакты',
    description:
      'Добро пожаловать в Fire & Ice. Мы посвящаем себя оптимизации вашего здоровья и жизненной энергии через контрастную терапию и услуги восстановления.',
    contactInfo: 'Контактная информация',
    addressLabel: 'Адрес',
    emailLabel: 'Электронная почта',
    phoneLabel: 'Телефон',
    howToFindUs: 'Как нас найти',
    directions:
      'Мы находимся по адресу Hobujaama 4. Ищите вход рядом с главной пешеходной дорожкой.',
  },

  // Hero Section
  hero: {
    title: 'Жизненная Cила',
    subtitle: 'Fire and Ice — инновационная велнес-студия, которая поможет вам…',
    benefit1: 'Достигать Большего',
    benefit2: 'Чувствовать Себя Лучше',
    benefit3: 'Работать Лучше',
    benefit4: 'Спать Лучше',
    benefit5: 'Жить Лучше',
  },

  services: 'Услуги',
  learnMore: 'Узнать больше',
  ourServices: 'Наши Услуги',
  ourPackages: 'Ознакомьтесь с нашими пакетами услуг.',
  packageIncludes: 'В комплект входит:',
  bookPackage: 'Забронируйте пакет услуг',
  min: 'мин',

  // Auth
  auth: {
    logout: 'Выйти',
    accountDeactivated: 'Аккаунт деактивирован',
    accountDeactivatedMessage:
      'Ваш аккаунт был деактивирован. Пожалуйста, обратитесь в службу поддержки для получения помощи.',
  },

  // Session Bundles Page
  sessionBundles: {
    title: 'Наши пакеты и абонементы',
    subtitle: 'Выберите идеальный пакет для вашего путешествия к здоровью',
    loadingSessionBundles: 'Загрузка комплексов сессий...',
    loadError: 'Не удалось загрузить комплексы сессий. Пожалуйста, попробуйте позже.',
    purchase: 'Купить',
    subscribe: 'Оформить подписку',
    per: 'в',
    monthlySubscriptions: 'Ежемесячные подписки',
    monthlySubscriptionsSpouse: 'Ежемесячные подписки со скидкой для супруга',
    bulkSessionBundles: 'Комплексы сессий (разовая покупка)',
    bulkSessionBundlesSpouse: 'Комплексы сессий со скидкой для супруга',
    showSpousePricing: 'Показать цены для супругов',
    spouseDisclaimer:
      '* Цены для супругов доступны связанным аккаунтам. Право на скидку будет подтверждено при входе в систему.',
    sessionBundleTypeMonthly: 'Ежемесячный',
    spouseOffer: 'Предложение для супруга',
    discountOff: '{{percentage}}% скидка',
    discountOffForMonths: '{{percentage}}% скидка на {{months}} месяцев',
    perSession: 'за сеанс',
  },

  // Pricing Page
  pricing: {
    title: 'Цены',
    subtitle: 'Выберите идеальный пакет для вашего путешествия к здоровью',
    membership: 'Членство',
    sessionBundle: 'Комплекс сессий',
    package: 'Упаковка',
    pack: 'Пакет',
    packs: 'Наборы',
    visitsPerMonth: 'Посещений/мес',
    sessions: 'Сеансы',
    regularPrice: 'Обычная цена',
    price: 'Цена',
    openingDeal: 'Скидка на открытие (-{{percentage}}%)',
    openingDealSessionBundle: 'Скидка на открытие (-{{percentage}}%)',
    pricePerSession: 'Цена/сеанс',
    notes: 'Примечания',
  },

  // Booking Page
  booking: {
    title: 'Забронировать сеанс',
    selectService: 'Выберите услугу',
    selectDateTime: 'Выберите дату и время',
    loadingServices: 'Загрузка услуг...',
    loadError: 'Не удалось загрузить услуги. Пожалуйста, попробуйте позже.',
    duration: 'Продолжительность',
    minutes: 'минут',
    noAvailableSlots: 'Нет доступного времени',
    selectTime: 'Выбрать Время',
    confirmBooking: 'Подтвердить бронирование',
    bookingDetails: 'Детали бронирования',
    service: 'Услуга',
    date: 'Дата',
    time: 'Время',
    confirmButton: 'Подтвердить бронирование',
    processing: 'Обработка...',
    success: 'Бронирование успешно подтверждено!',
    error: 'Не удалось подтвердить бронирование. Пожалуйста, попробуйте снова.',
    step1: 'Шаг 1 из 3: Выберите услугу',
    step2: 'Шаг 2 из 3: Выберите дату и время',
    step3: 'Шаг 3 из 3: Подтвердите бронирование',
    selectDate: 'Выберите дату',
    loadingAvailableTimes: 'Загрузка доступного времени...',
    noAvailableTimesForDate: 'Нет доступного времени на эту дату',
    confirmYourBooking: 'Подтвердите ваше бронирование',
    confirmYourDetails: 'Шаг 3 из 3: Подтвердите ваши данные',
    serviceLabel: 'Услуга:',
    dateLabel: 'Дата:',
    timeLabel: 'Время:',
    durationLabel: 'Продолжительность:',
    totalLabel: 'Итого:',
    contactInformation: 'Контактная информация',
    phoneNumberRequired: 'Номер телефона требуется для подтверждения бронирования',
    phoneNumberInvalid: 'Пожалуйста, введите корректный номер телефона',
    phoneNumberTooShortEst: 'Эстонские номера должны содержать минимум 7 цифр',
    phoneNumberTooLongEst: 'Эстонские номера могут содержать максимум 8 цифр',
    phoneNumberTooShort: 'Номер телефона слишком короткий',
    phoneNumberTooLong: 'Номер телефона слишком длинный',
    confirming: 'Подтверждение...',
    bookingFailed: 'Не удалось создать бронирование. Пожалуйста, попробуйте снова.',
    step2ChooseDateTime: 'Шаг 2 из 3: Выберите дату и время',
    bookAllSessions:
      'Пожалуйста, запишитесь на все сеансы терапии, включенные в пакет. Сеансы могут проводиться в разные дни.',
    rescheduleTitle: 'Перенести бронирование',
    rescheduleSubtitle: 'Выберите новую дату и время для вашего бронирования',
    currentBooking: 'Текущее бронирование',
    confirmReschedule: 'Подтвердить перенос',
    reschedulingSuccess: 'Ваше бронирование успешно перенесено!',
    reschedulingError: 'Не удалось перенести бронирование. Пожалуйста, попробуйте снова.',
    participantsLabel: 'Участники',
    enterGiftCardCode: 'Пожалуйста, введите код подарочной карты',
    invalidGiftCardCode: 'Неверный код подарочной карты',
    giftCardError: 'Ошибка при применении подарочной карты',
    giftCardRedemptionFailed:
      'Не удалось использовать подарочную карту. Пожалуйста, попробуйте снова.',
    giftCard: 'Подарочная карта',
    applying: 'Применение...',
    apply: 'Применить',
    fullyCoveredByGiftCard: 'Ваше бронирование полностью покрыто подарочной картой!',
    noPaymentRequired: 'Дополнительная оплата не требуется.',
    balance: 'Баланс',
    remainingBalance: 'Остаток баланса',
    remove: 'Удалить',
    priceLabel: 'Цена:',
    confirmAndPay: 'Подтвердить и оплатить',
    nameRequired: 'Имя обязательно',
    emailRequired: 'Электронная почта обязательна',
    emailInvalid: 'Неверный формат электронной почты',
    enterYourName: 'Введите ваше имя',
    enterYourEmail: 'Введите вашу электронную почту',
    guestBookingSuccess:
      'Бронирование подтверждено! Вы получите подтверждение по электронной почте.',
    bulkBookingSuccess: 'Успешно создано бронирований: {{count}}!',
    bulkBookingSuccessTitle: 'Бронирования успешно подтверждены!',
    bookAnotherSession: 'Забронировать еще',
    chooseHowToProceed: 'Выберите, как вы хотите продолжить бронирование:',
    continueAsGuest: 'Продолжить как гость',
    loginToBook: 'Войти или Зарегистрироваться, если у вас есть аккаунт',
    paymentOption: 'Способ оплаты',
    isMixedCart:
      'В одном заказе нельзя комбинировать разные способы оплаты услуг и пакетов. Оплата за разные товары и услуги возможна только картой или на месте.',
    remainingSessions: 'Оставшиеся сеансы',
    subscriptions: 'Подписки',
    sessionBundles: 'Комплексы сессий',
    payByCard: 'Оплата картой',
    payAtSite: 'Оплата на месте',
    paymentMethods: 'Способы оплаты',
    infoSavedNote: 'Ваша информация сохранена для будущих бронирований',
    unavailableTitle: 'Недоступные подписки и пакеты',
    unavailableMessage: 'Эти подписки и пакеты истекли или полностью использованы.',
    sessionsRemaining: 'Оставшиеся сеансы',
    status: 'Статус',
    expired: 'Истек',
    insufficientCredits:
      'У вас доступно {{available}} сеансов, но вы пытаетесь забронировать {{required}} сеансов.',
    insufficientCreditsActionStart: 'Пожалуйста, ',
    insufficientCreditsActionModify: 'измените бронирование',
    insufficientCreditsActionMiddle: ' или ',
    insufficientCreditsActionPurchase: 'приобретите дополнительный пакет',
    insufficientCreditsActionEnd: '.',
  },

  // Account Page
  account: {
    title: 'Мой аккаунт',
    personalInfo: 'Персональная информация',
    email: 'Электронная почта',
    name: 'Имя',
    phoneNumber: 'Номер телефона',
    gender: 'Пол',
    birthday: 'Дата рождения',
    upcomingBookings: 'Предстоящие бронирования',
    pastBookings: 'Прошедшие бронирования',
    cancelledBookings: 'Отмененные бронирования',
    noBookings: 'Бронирования не найдены',
    cancelBooking: 'Отменить',
    cancelBookingConfirmTitle: 'Отменить это бронирование?',
    cancelBookingConfirmMessage:
      'Вы уверены, что хотите отменить бронирование {{serviceName}} на {{date}} в {{time}}?',
    cancelBookingYes: 'Да, отменить бронирование',
    cancelBookingNo: 'Оставить бронирование',
    confirm: 'Подтвердить',
    rescheduleBooking: 'Перенести',
    profile: 'Профиль',
    mySessionBundle: 'Мой комплекс сессий',
    mySessionBundlesAndSubscriptions: 'Мои пакеты услуг, подписки и комплекты.',
    bookings: 'Бронирования',
    notProvided: 'Не указано',
    edit: 'Редактировать',
    save: 'Сохранить',
    cancel: 'Отмена',
    sessionsLeft: 'Осталось сеансов',
    expires: 'Истекает',
    activeSessionBundles: 'Активные комплексы сессий',
    viewAllBookings: 'Посмотреть все бронирования',
    spouseDiscount: 'Скидка для супруга',
    spouseDiscountDesc:
      'Введите email вашего супруга, чтобы предоставить им доступ к пакетам со скидкой.',
    sendInvite: 'Отправить приглашение',
    spouse: {
      title: 'Аккаунт супруга',
      linked: 'Ваш аккаунт связан с: {{email}}',
      pending: 'Приглашение ожидает ответа: {{email}}',
      declined:
        'Ваше предыдущее приглашение на {{email}} было отклонено. Вы можете ввести новый email или тот же, чтобы попробовать снова.',
      invite: 'Введите email вашего супруга, чтобы отправить приглашение для связывания.',
    },
    manageSubscription: 'Управление подпиской',
    sessionsRemaining: 'Осталось сеансов',
    sessionsUsed: 'Использовано/забронировано сеансов',
    renewalDate: 'Дата продления',
    activeSubscription: 'Активная подписка',
    renewsOn: 'Продлевается',
    loadingBookings: 'Загрузка бронирований...',
    noBookingsYet: 'Пока нет бронирований. Забронируйте ваш первый сеанс!',
    minutes: 'минут',
    phoneNumberUpdated: 'Номер телефона успешно обновлен!',
    preferencesUpdated: 'Настройки успешно обновлены!',
    promoOptIn: 'Я хочу получать рекламные письма и новостные рассылки.',
    invitationSent: 'Приглашение успешно отправлено!',
    welcomeMessage:
      'Спасибо за регистрацию в Fire & Ice! Мы рады приветствовать вас в нашем сообществе здоровья. Уделите время изучению вашего аккаунта и ознакомьтесь со всеми нашими потрясающими услугами.',
    // Booking cancellation
    bookingCancelledSuccess: 'Бронирование успешно отменено!',
    bookingCancelFailed: 'Не удалось отменить бронирование. Пожалуйста, попробуйте снова.',
    cancellationPolicy24Hours:
      'Бронирования не могут быть отменены менее чем за 24 часа до начала сеанса.',
    reschedulingPolicy24Hours:
      'Бронирования не могут быть перенесены менее чем за 24 часа до начала сеанса.',
    cannotCancel24Hours: 'Отмена невозможна',
    cannotReschedule24Hours: 'Перенос невозможен',
    cancellationPolicyNotice:
      'Примечание: Бронирования не могут быть отменены менее чем за 24 часа до начала сеанса.',
    // Phone number validation errors
    phoneNumberTooShortEst: 'Эстонские номера должны содержать минимум 7 цифр',
    phoneNumberTooLongEst: 'Эстонские номера могут содержать максимум 8 цифр',
    phoneNumberTooShort: 'Номер телефона слишком короткий',
    phoneNumberTooLong: 'Номер телефона слишком длинный',
    phoneNumberInvalid: 'Пожалуйста, введите корректный номер телефона',
    unusedSessionsNote: 'Ваши неиспользованные сеансы будут перенесены на срок до 3 месяцев.',
    confirmed: 'подтверждено',
    cancelled: 'отменено',
    at: 'в',
    sessionsRolledOver: 'Перенесено',
    expiresOn: 'Истекает',
    bookAgain: 'Забронировать снова',
    filterAll: 'Все',
    filterUpcoming: 'Предстоящие',
    filterPast: 'Прошедшие',
    filterCancelled: 'Отмененные',
    searchBookings: 'Поиск бронирований...',
    noUpcomingBookings: 'Нет предстоящих бронирований',
    readyToBook: 'Готовы забронировать следующий оздоровительный сеанс?',
    noPastBookings: 'Нет прошедших бронирований',
    bookingHistoryWillAppear: 'Ваша история бронирований появится здесь',
    noCancelledBookings: 'Нет отмененных бронирований',
    cancelledBookingsWillAppear: 'Отмененные бронирования появятся здесь',
    bookYourFirstSession: 'Забронируйте ваш первый сеанс',
    participants: 'участников',
    loadingSessionBundles: 'Загрузка комплексов сессий...',
    noActiveSessionBundles: 'Нет активных комплексов сессий',
    myPackagePacks: 'Мои пакет-паки',
    noActivePackagePacks: 'Нет активных пакет-паков',
    packsRemaining: 'Пакетов осталось',
    packsUsed: 'Использовано пакетов',
    usedPackagePacksTitle: 'Использованные пакет-паки',
    // Subscription management
    mySubscription: 'Моя подписка',
    subscription: 'Подписка',
    cancelSubscription: 'Отменить подписку',
    cancelConfirmTitle: 'Отменить подписку?',
    cancelConfirmMessage:
      'Вы уверены, что хотите отменить? Ваши преимущества будут действовать до {{endDate}}.',
    cancelSuccess: 'Ваша подписка отменена и истечет {{endDate}}.',
    cancelError: 'Не удалось отменить подписку. Пожалуйста, обратитесь в службу поддержки.',
    subscriptionExpires: 'Ваша подписка активна и истечет {{endDate}}.',
    subscriptionRenews: 'Ваша подписка возобновится {{endDate}}.',
    keep: 'Сохранить подписку',
    noActiveSubscription: 'Нет активных подписок',
    nameRequired: 'Имя обязательно',
    nameUpdated: 'Имя успешно обновлено',
    emailInvalid: 'Пожалуйста, введите действительный адрес электронной почты',
    emailUpdateInitiated:
      'Требуется подтверждение. Пожалуйста, проверьте свой новый адрес электронной почты для получения ссылки подтверждения.',
    emailChangeSubmitted:
      'Мы отправили ссылку подтверждения на ваш новый адрес электронной почты. Пожалуйста, нажмите на ссылку в этом письме, чтобы завершить изменение.',
    expiredSectionTitle: 'Истекшие подписки и использованные пакеты',
    subscriptionExpiredOn: 'Истек',
    sessionBundleFullyUsed: 'Комплекс сессий полностью использован',
    notificationPreferences: 'Настройки уведомлений',
    receiveEmailReminders: 'Получать напоминания о бронировании по электронной почте',
    receiveSmsReminders: 'Получать напоминания о бронировании по SMS',
    noPhoneNumber: 'Номер телефона не указан',
    addPhoneToEnable: 'Добавьте телефон для активации',
    session: 'Сеанс',
  },

  // Email Verification
  verifyEmail: {
    title: 'Подтверждение электронной почты',
    verifying: 'Подтверждение вашей электронной почты...',
    success: 'Ваш адрес электронной почты успешно обновлен!',
    errorTitle: 'Ошибка подтверждения',
    noToken: 'Токен подтверждения не найден.',
    genericError: 'Произошла ошибка.',
    backToAccount: 'Перейти в мой аккаунт',
    redirecting: 'Вы будете перенаправлены в свой профиль через 3 секунды...',
    clickHereToReturn:
      'Если вы не будете перенаправлены, нажмите здесь, чтобы вернуться в свой профиль.',
  },

  // Email Templates
  email: {
    verification: {
      subject: 'Подтвердите ваш новый адрес электронной почты - Fire & Ice',
      heading: 'Подтвердите ваш новый адрес электронной почты',
      body: 'Вы недавно запросили изменение адреса электронной почты, связанного с вашим аккаунтом Fire & Ice. Чтобы подтвердить это изменение, пожалуйста, нажмите кнопку ниже. Ссылка действительна в течение 1 часа.',
      button: 'Подтвердить новый адрес электронной почты',
      disclaimer:
        'Если вы не запрашивали это изменение адреса электронной почты, вы можете спокойно проигнорировать это письмо.',
    },
    bookingConfirmation: {
      subject: 'Подтверждение вашего бронирования Fire & Ice',
      heading: 'Бронирование подтверждено!',
      greeting: 'Здравствуйте',
      bodyIntro: 'Спасибо за ваше бронирование. Вот детали вашей предстоящей сессии:',
      bookingListHeader: 'Ваши бронирования',
      payAtSiteLabel: 'Сумма к оплате в студии',
    },
    bookingReminder: {
      subject: 'Напоминание: Ваше бронирование Fire & Ice завтра',
      heading: '⏰ Напоминание о бронировании',
      greeting: 'Здравствуйте',
      bodyIntro: 'Это дружеское напоминание о том, что у вас есть бронирование на завтра.',
      closingMessage: 'Ждем вас с нетерпением!',
      footerMessage: 'Это автоматическое напоминание о вашем предстоящем бронировании.',
    },
    dailyReminder: {
      subject: 'Напоминание: Ваши бронирования Fire & Ice сегодня',
      heading: 'Fire & Ice напоминание о бронировании',
      greeting: 'Здравствуйте',
      greetingSingle: 'У вас сегодня встреча:',
      greetingMultiple: 'У вас сегодня {{count}} встреч(и):',
      closingMessage: 'Ждем вас с нетерпением!',
      footerMessage: 'Это автоматическое напоминание о вашем предстоящем бронировании(ях).',
    },
    purchaseConfirmation: {
      subject: 'Подтверждение вашей покупки Fire & Ice',
      heading: 'Покупка подтверждена!',
      bodyIntroSessionBundle:
        'Спасибо за покупку! Ваш новый комплекс сессий активен и готов к использованию.',
      bodyIntroSubscription:
        'Спасибо за покупку! Ваша новая подписка активна и готова к использованию.',
      detailsLabel: 'Детали покупки:',
      priceLabel: 'Оплаченная сумма:',
      sessionBundleInfo:
        'Вы купили {{sessions}} сессий. Нет ограничений по времени использования ваших сессий - они никогда не истекают!',
      subscriptionInfo:
        'Ваша подписка автоматически продлится {{renewalDate}}. Неиспользованные сессии переносятся на срок до 3 месяцев. Вы можете отменить подписку в любое время в разделе вашего аккаунта на сайте Fire & Ice.',
      ctaHeading: 'Готовы начать?',
      ctaBody:
        'Ознакомьтесь с нашим ассортиментом оздоровительных услуг и забронируйте свою первую сессию сегодня. Мы с нетерпением ждем вас в Fire & Ice!',
      ctaButton: 'Забронировать первую сессию',
    },
    rescheduleConfirmation: {
      subject: 'Ваше бронирование Fire & Ice было перенесено',
      heading: 'Бронирование перенесено',
      bodyIntro: 'Ваше бронирование для следующей услуги было успешно перенесено:',
      serviceLabel: 'Услуга:',
      oldBookingHeading: 'Прежнее время',
      newBookingHeading: 'Новое время',
      dateLabel: 'Дата:',
      timeLabel: 'Время:',
    },
    cancellationConfirmation: {
      subject: 'Ваше бронирование Fire & Ice было отменено',
      heading: 'Бронирование отменено',
      bodyIntro: 'Ваше бронирование для следующей услуги было успешно отменено:',
      bookingDetails: 'Детали отмененного бронирования:',
      serviceLabel: 'Услуга:',
      dateLabel: 'Дата:',
      timeLabel: 'Время:',
      refundNoticeSessionBundle: 'Кредит сессии возвращен в ваш активный комплекс сессий.',
      refundNoticeSubscription: 'Кредит сессии возвращен в вашу активную подписку.',
      refundNoticePaid: 'Ваше бронирование было оплачено картой и не подлежит возврату.',
      refundNoticeDefault: 'Ваше бронирование было отменено.',
    },
    spouseInvite: {
      subject: 'Приглашение к аккаунту супруга - Fire & Ice',
      heading: 'Вас приглашают!',
      body: 'пригласил вас связать ваш аккаунт Fire & Ice как супруга.',
      acceptButton: 'Принять приглашение',
      declineButton: 'Отклонить',
    },
    spouseResponse: {
      subject: 'Ответ на приглашение супруга - Fire & Ice',
      heading: 'Ответ на приглашение',
      bodyAccepted: 'принял ваше приглашение к аккаунту супруга!',
      bodyDeclined: 'отклонил ваше приглашение к аккаунту супруга.',
    },
    footer: {
      company: 'Fire and Ice',
      address: 'Hobujaama tn 4, Tallinn',
      emailSentTo: 'Это письмо было отправлено на',
      reason: 'Вы получили это письмо, потому что зарегистрировались в Fire & Ice.',
    },
  },

  // Complete Registration
  registration: {
    title: 'Завершите регистрацию',
    subtitle: 'Пожалуйста, предоставьте следующую информацию для завершения настройки аккаунта',
    firstName: 'Имя',
    lastName: 'Фамилия',
    phoneNumber: 'Номер телефона',
    phoneNumberPlaceholder: 'например, +372 5123 4567',
    submit: 'Завершить регистрацию',
    submitting: 'Отправка...',
    success: 'Регистрация успешно завершена!',
    error: 'Не удалось завершить регистрацию. Пожалуйста, попробуйте снова.',
    oneLastStep: 'Последний шаг...',
    welcome: 'Добро пожаловать в Fire & Ice',
    reviewTerms:
      'Пожалуйста, ознакомьтесь и согласитесь с условиями ниже для завершения регистрации.',
    agreeToTerms: 'Я согласен с',
    termsOfService: 'Условиями предоставления услуг',
    promoOptIn: 'Я хочу получать рекламные письма и новостные рассылки.',
    agreeToEmails: 'Я согласен получать рекламные рассылки',
    completeSignUp: 'Завершить регистрацию',
    completing: 'Завершение...',
    mustAgreeToTerms: 'Вы должны согласиться с Условиями предоставления услуг для продолжения.',
    errorOccurred: 'Произошла ошибка. Пожалуйста, попробуйте снова.',
    nameLabel: 'Полное имя',
    namePlaceholder: 'Введите ваше полное имя',
    nameRequired: 'Пожалуйста, введите ваше имя.',
    gender: 'Пол',
    genderPlaceholder: 'Выберите ваш пол',
    male: 'Мужской',
    female: 'Женский',
    birthday: 'Дата рождения',
    birthdayPlaceholder: 'Выберите вашу дату рождения',
    birthdayInFuture: 'Дата рождения не может быть в будущем',
  },

  // Error messages
  errors: {
    unauthorized: 'Вам необходимо войти в систему для доступа к этой странице',
    notFound: 'Страница не найдена',
    general: 'Что-то пошло не так. Пожалуйста, попробуйте снова.',
    // Auth callback errors
    authenticationError: 'Ошибка аутентификации',
    authenticationErrorMessage:
      'Произошла ошибка при аутентификации. Вы будете перенаправлены на главную страницу.',
    authError: 'Ошибка: {{message}}',
    redirecting: 'Перенаправление...',
    authenticating: 'Аутентификация...',
    loading: 'Загрузка...',
    missingCallbackParams: 'Отсутствуют необходимые параметры обратного вызова',
    // Auth0 configuration errors
    auth0ConfigMissing:
      'Отсутствует конфигурация Auth0. Пожалуйста, проверьте переменные окружения REACT_APP_AUTH0_DOMAIN и REACT_APP_AUTH0_CLIENT_ID.',
    auth0ConfigError: 'Ошибка конфигурации Auth0. Пожалуйста, проверьте консоль для подробностей.',
    confirmationFailed: 'Подтверждение не удалось. ',
    paymentNotSucceeded: 'Платеж не прошел.',

    // API Error Codes
    api: {
      AUTH_TOKEN_MISSING: 'Требуется аутентификация. Пожалуйста, войдите в систему.',
      AUTH_TOKEN_INVALID: 'Срок действия вашей сессии истек. Пожалуйста, войдите снова.',
      AUTH_UNAUTHORIZED: 'У вас нет прав для выполнения этого действия.',

      BOOKING_NOT_FOUND: 'Бронирование не найдено.',
      BOOKING_CANNOT_CANCEL: 'Невозможно отменить бронирование менее чем за 24 часа до приема.',
      BOOKING_ALREADY_CANCELLED: 'Это бронирование уже отменено.',
      BOOKING_SLOT_UNAVAILABLE: 'Это время больше не доступно.',
      BOOKING_INVALID_DATA: 'Предоставлена неверная информация о бронировании.',
      BOOKING_REQUIRED_FIELDS_MISSING: 'Отсутствует обязательная информация о бронировании.',
      BOOKING_BULK_PARTIAL_FAILURE: 'Некоторые бронирования не удалось завершить.',
      BOOKING_BULK_COMPLETE_FAILURE: 'Не удалось завершить бронирования.',

      PAYMENT_REQUIRED: 'Для завершения этого бронирования требуется оплата.',
      PAYMENT_FAILED: 'Оплата не удалась. Пожалуйста, попробуйте снова.',
      PAYMENT_INVALID_AMOUNT: 'Неверная сумма платежа.',
      PAYMENT_CARD_DECLINED: 'Ваша карта отклонена. Пожалуйста, попробуйте другой способ оплаты.',

      GIFT_CARD_NOT_FOUND: 'Подарочная карта не найдена или недействительна.',
      GIFT_CARD_INSUFFICIENT_BALANCE: 'Недостаточный баланс подарочной карты.',
      GIFT_CARD_INVALID_AMOUNT: 'Неверная сумма подарочной карты.',

      PROMO_CODE_NOT_FOUND: 'Промокод не найден или недействителен.',

      SESSION_BUNDLE_NOT_FOUND: 'Пакет или подписка не найдены.',
      SESSION_BUNDLE_NO_USES_REMAINING: 'У этого пакета не осталось использований.',
      SESSION_BUNDLE_ALREADY_PURCHASED: 'У вас уже есть этот пакет.',

      USER_NOT_FOUND: 'Пользователь не найден.',
      CLIENT_NOT_FOUND: 'Клиент не найден.',

      SERVICE_NOT_FOUND: 'Услуга не найдена.',
      SERVICE_UNAVAILABLE: 'Эта услуга в данный момент недоступна.',

      INVALID_REQUEST: 'Неверный запрос.',
      VALIDATION_ERROR: 'Пожалуйста, проверьте введенные данные и попробуйте снова.',

      INTERNAL_ERROR: 'Произошла ошибка. Пожалуйста, попробуйте снова.',
      EXTERNAL_API_ERROR: 'Сервис временно недоступен. Пожалуйста, попробуйте позже.',
    },
  },

  // Date/Time formatting
  dateTime: {
    today: 'Сегодня',
    tomorrow: 'Завтра',
    weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    months: [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ],
  },

  // Footer
  footer: {
    services: 'УСЛУГИ',
    infraredSauna: 'Инфракрасная сауна',
    coldPlunge: 'Холодное погружение',
    cryotherapy: 'Криотерапия',
    redLightTherapy: 'Красная светотерапия',
    cellumaFacialLightTherapy: 'Celluma лицевая светотерапия',
    compressionMassage: 'Компрессионный массаж',
    gallery: 'ГАЛЕРЕЯ',
    scienceAndStudies: 'НАУКА И ИССЛЕДОВАНИЯ',
    specialOffers: 'СПЕЦИАЛЬНЫЕ ПРЕДЛОЖЕНИЯ',
    pricing: 'ЦЕНЫ',
    bookNow: 'ЗАБРОНИРОВАТЬ',
    copyright: '© {year} Fire and Ice. Все права защищены.',
    checkGiftCardBalance: 'Проверить баланс подарочной карты',
    privacyNotice: 'Уведомление о конфиденциальности',
    termsOfService: 'Условия использования',
  },

  // Promotion
  promo: {
    code: 'Промо-код',
    have: 'Есть промокод?',
    applied: 'Промокод применен',
    placeholder: 'Введите промокод',
    errors: {
      missingCode: 'Пожалуйста, введите промокод.',
      validationError: 'Произошла ошибка при проверке промокода.',
      invalidCode: 'Недействительный промокод',
    },
  },

  // Gift Card
  giftCard: {
    have: 'Есть подарочная карта?',
    applied: 'Подарочная карта применена',
    purchaseTitle: 'Купить цифровую подарочную карту Fire & Ice',
    purchaseDescription:
      'Эта подарочная карта действительна в течение одного года и может быть использована для оплаты бронирований, покупки пакетов или подписок.',
    chooseAmount: 'Выберите сумму',
    other: 'Другая',
    enterAmountPlaceholder: 'Введите сумму - минимум 50 €',
    to: 'Кому:',
    recipientName: 'Имя получателя',
    recipientNamePlaceholder: 'Иван Иванов',
    deliveryEmail: 'Email для доставки',
    recipientEmailPlaceholder: 'ivan@example.com',
    from: 'От кого:',
    yourName: 'Ваше имя',
    yourNamePlaceholder: 'Ваше имя',
    yourEmail: 'Ваш Email',
    yourEmailPlaceholder: 'your@example.com',
    yourPhone: 'Ваш телефон',
    yourPhonePlaceholder: '+372 5123 4567',
    personalMessage: 'Добавьте персональное сообщение (необязательно)',
    personalMessagePlaceholder: 'Напишите ваше сообщение здесь...',
    characters: 'символов',
    processing: 'Обработка...',
    proceedToPayment: 'Перейти к оплате',
    completePayment: 'Завершить оплату',
    minimumAmountError: 'Минимальная сумма подарочной карты 50 €',
    successMessage: 'Подарочная карта успешно создана! Код: {{code}}',
    errorMessage:
      'Не удалось создать подарочную карту. Пожалуйста, проверьте данные и попробуйте снова.',
    session: '{{count}} сеанс',
    sessions: '{{count}} сеансов',
    // Gift Card Balance Page
    balancePageTitle: 'Проверьте баланс вашей подарочной карты',
    balancePageSubtitle: 'Введите код вашей подарочной карты ниже, чтобы увидеть остаток.',
    codePlaceholder: 'XXXX-XXXX-XXXX',
    checkingBalance: 'Проверка...',
    checkBalance: 'Проверить баланс',
    currentBalance: 'Текущий баланс:',
    invalidCode: 'Неверный код подарочной карты.',
    checkError: 'Произошла ошибка. Пожалуйста, попробуйте снова.',
    enterCode: 'Пожалуйста, введите код подарочной карты.',
    cardDepleted: 'Эта подарочная карта полностью использована и больше недействительна.',
    successPageTitle: 'Покупка подарочной карты прошла успешно!',
    successPageMessage: 'Ваша подарочная карта была куплена и отправлена получателю.',
    detailsTitle: 'Детали покупки',
    giftCardCode: 'Код подарочной карты',
    codeInfo: 'Получатель получит этот код по электронной почте.',
    amount: 'Сумма',
    emailConfirmation: 'Письмо с подтверждением было отправлено на {{email}}.',
    emailSubject: 'Вы получили подарочную карту от {{senderName}}!',
    emailHeading: 'Вы получили подарочную карту!',
    emailIntro: 'отправил вам подарочную карту!',
    amountLabel: 'Стоимость подарочной карты',
    codeLabel: 'Код вашей подарочной карты',
    messageLabel: 'Персональное сообщение',
    emailInstructions:
      'Используйте этот код при бронировании следующей сессии в Fire & Ice или для покупки пакетов и подписок.',
    ctaText: 'Забронировать',
  },

  // Booking Upsell
  upsell: {
    message: 'Бронируете отдельные сеансы? Использование подписки или пакета дешевле.',
    linkText: 'Просмотреть пакеты и членство',
  },

  // Service Page
  servicePage: {
    bookNow: 'Забронировать сейчас',
  },

  // Booking Cart
  cart: {
    title: 'Ваш выбор бронирования',
    empty: 'Ваш выбор пуст.',
    addToCart: 'Забронировать Время',
    bookNow: 'Забронировать сейчас',
    addedToCart: 'Добавлено в ваш выбор бронирования!',
    bookingChanged: 'Бронирование изменено',
    change: 'Изменить',
    remove: 'Удалить',
    confirmRemove: 'Вы уверены, что хотите удалить это бронирование из корзины?',
    total: 'Итого',
    at: 'в',
    addAnotherService: 'Добавить другую услугу',
    proceedToCheckout: 'Завершить Бронирование',
    suggestedServices: 'Продолжите свой путь к здоровью',
    suggestedServicesDescription: 'Эти услуги доступны сразу после вашего последнего бронирования:',
    available: 'Доступно в',
    bookingSelected: '{{count}} Бронирование Выбрано',
    bookingsSelected: '{{count}} Бронирований Выбрано',
    removeBookingTitle: 'Удалить Бронирование',
    confirmChange: 'Подтвердить Изменение',
    credits: 'Кредиты',
    participants: 'Участники:',
    participantEmails: 'E-mail участников (необязательно):',
    participantEmailPlaceholder: 'E-mail участника {{count}}',
  },

  // Checkout Page
  checkout: {
    title: 'Оформление заказа',
    bookingSummary: 'Сводка бронирований',
    orderSummary: 'Итог заказа',
    paymentDetails: 'Детали оплаты',
    securePaymentInfo: 'Ваш платеж безопасно обрабатывается через Stripe.',
    cardDetails: 'Данные карты',
    cardNumber: 'Номер карты',
    expiryDate: 'Срок действия',
    cvc: 'CVC',
    processing: 'Обработка...',
    completeOrder: 'Завершить заказ',
    payAmount: 'Оплатить {{amount}}',
    cardElementError: 'Элемент карты не найден',
    paymentError: 'Платеж не прошел. Пожалуйста, попробуйте снова.',
    sessionBundleNotFound: 'Комплекс сессий не найден',
    packagePackNotFound: 'Упаковка не найдена',
    loadError: 'Не удалось загрузить детали пакета',
    enterGiftCardCode: 'Пожалуйста, введите код подарочной карты',
    giftCardNoBalance: 'У этой подарочной карты нет баланса',
    invalidCode: 'Неверный код',
    monthlySubscription: 'Ежемесячная подписка',
    bulkSessionBundle: 'Комплекс сессий',
    sessions: 'сеансов',
    subtotal: 'Подитог',
    promotionDiscount: 'Скидка по акции',
    promotionCodeDiscount: 'промокод скидка',
    giftCardDiscount: 'Скидка по подарочной карте',
    total: 'Итого',
    enterCode: 'Введите код',
    apply: 'Применить',
    remove: 'Удалить',
    customerInfo: 'Информация о клиенте',
    name: 'Имя',
    email: 'Электронная почта',
    unavailable: 'Недоступно',
    unavailableItemsMessage:
      'Некоторые бронирования больше недоступны. Пожалуйста, удалите их, чтобы продолжить.',
    removeUnavailable: 'Удалить Недоступные Бронирования',
    bookingInfo:
      'Ваши бронирования будут подтверждены немедленно. Вы можете управлять ими на странице вашего аккаунта.',
    confirmBookings: 'Подтвердить Бронирования',
    processingOrder: 'Обработка заказа',
    pleaseWait: 'Пожалуйста, подождите, пока мы подтверждаем вашу покупку...',
  },

  // Purchase Confirmation Page
  confirmation: {
    title: 'Подтверждение покупки',
    successTitle: 'Спасибо за вашу покупку!',
    successMessage: 'Ваш заказ успешно оформлен.',
    noData: 'Информация о заказе недоступна',
    orderDetails: 'Детали заказа',
    sessionBundle: 'Комплекс сессий',
    subscription: 'Подписка',
    amountPaid: 'Оплаченная сумма',
    paymentMethod: 'Способ оплаты',
    giftCardOnly: 'Подарочная карта',
    cardAndGiftCard: 'Кредитная карта и подарочная карта',
    whatNext: 'Что дальше?',
    confirmationEmail: 'Вы получите письмо с подтверждением вскоре с деталями вашей покупки.',
    bookSession: 'Забронировать сеанс',
    goToAccount: 'Перейти в мой аккаунт',
    contractError:
      'Возникла проблема с активацией вашего пакета. Пожалуйста, свяжитесь со службой поддержки.',
    creatingContract: 'Завершение вашей покупки, пожалуйста, подождите...',
  },

  // Newsletter
  newsletter: {
    title: 'Оставайтесь в курсе',
    subtitle:
      'Подпишитесь на нашу рассылку, чтобы получать последние новости и советы по здоровью.',
    firstNamePlaceholder: 'Имя',
    lastNamePlaceholder: 'Фамилия',
    emailPlaceholder: 'Введите ваш email',
    subscribing: 'Подписка...',
    subscribe: 'Подписаться',
    successMessage: 'Спасибо за подписку!',
    errorMessage: 'Что-то пошло не так. Пожалуйста, попробуйте снова.',
  },

  // Console messages (for debugging)
  console: {
    errors: {
      fetchingBookings: 'Ошибка при получении бронирований:',
      fetchingUserSessionBundles: 'Ошибка при получении пакетов пользователя:',
      cancellingBooking: 'Ошибка при отмене бронирования:',
      fetchingSessionBundles: 'Ошибка при получении комплексов сессий:',
      fetchingServices: 'Ошибка при получении услуг:',
      completingRegistration: 'Ошибка при завершении регистрации:',
      creatingBooking: 'Ошибка при создании бронирования:',
      fetchingService: 'Ошибка при получении услуги:',
      fetchingAvailability: 'Ошибка при получении доступности:',
      reschedulingBooking: 'Ошибка при переносе бронирования:',
      fetchingGiftCardBalance: 'Ошибка при получении баланса подарочной карты:',
      giftCardRedemptionFailed: 'Не удалось использовать подарочную карту:',
      creatingGiftCard: 'Ошибка при создании подарочной карты:',
      authCallbackError: 'Ошибка обратного вызова Auth0:',
      authErrorDetails: 'Детали ошибки Auth0:',
    },
  },

  // Coupon Codes
  coupon: {
    title: 'Код купона',
    haveCoupon: 'Есть код купона?',
    placeholder: 'Введите код купона',
    applied: 'Купон применен!',
    sessionsIncluded: '{{count}} сеансов включено',
    sessionsAlreadyUsed: '{{count}} сеанс(а) уже использовано',
    bookAnotherLater: 'Забронируйте ещё один сеанс позже, чтобы использовать ваш бесплатный сеанс!',
    youSave: 'Вы экономите',
    cancellationPolicyTitle: 'Политика связанных бронирований',
    cancellationPolicyText:
      'Оба сеанса должны быть отменены вместе. Если вы отмените один сеанс, оба сеанса будут отменены, и купон будет восстановлен для будущего использования.',
    // Coupon pair cancellation
    sessionBadge: 'Купон',
    cancelPairTitle: 'Отменить сеансы по купону',
    linkedBookingNotice: 'Связанное бронирование по купону',
    pairCancellationExplanation:
      'Это бронирование является частью пары по купону. Для полного возврата оба сеанса должны быть отменены вместе.',
    pairCancellationConfirm:
      'Отмена отменит оба сеанса по купону и вернет {{amount}}. Ваш код купона будет восстановлен для будущего использования.',
    linkedSessions: 'Связанные сеансы для отмены:',
    cancelBothSessions: 'Отменить оба сеанса',
    pairCancellationSuccess:
      'Оба сеанса по купону успешно отменены. {{amount}} возвращено. Купон восстановлен для повторного использования.',
    errors: {
      missingCode: 'Пожалуйста, введите код купона.',
      missingEmail: 'Для проверки купона необходим адрес электронной почты.',
      invalidCode: 'Этот код купона недействителен или истек.',
      alreadyUsed: 'Этот код купона уже полностью использован.',
      noSessions: 'Пожалуйста, добавьте хотя бы один сеанс в корзину.',
      validationError: 'При проверке кода купона произошла ошибка.',
      sessionAlreadyUsed:
        'Отмена невозможна: один или несколько связанных сеансов уже использованы. Вы можете перенести бронирование в течение 24 часов до встречи.',
      cannotCancel: 'В настоящее время невозможно отменить эти сеансы.',
    },
    success: 'Купон применен! Вы экономите {{discount}}.',
  },

  // Gallery
  gallery: {
    title: 'Галерея',
    subtitle: 'Исследуйте моменты из нашей велнес-студии',
    pageTitle: 'Галерея',
    pageDescription: 'Просматривайте галерею велнес-впечатлений Fire & Ice в Таллинне.',
    viewImage: 'Просмотр изображения',
    lightboxLabel: 'Просмотр изображения',
    previousImage: 'Предыдущее изображение',
    nextImage: 'Следующее изображение',
    loadError: 'Не удалось загрузить галерею',
    noImages: 'Изображения недоступны',
  },

  // SEO
  seo: {
    defaultTitle: 'Fire & Ice - Велнес и восстановление',
    defaultDescription:
      'Испытайте максимальное велнес-путешествие с Fire & Ice. Премиальные услуги контрастной терапии, включая сауну, холодную ванну и многое другое в Таллинне.',
    homeDescription:
      'Fire and Ice — это место, где вы можете отдохнуть и позволить нам позаботиться о вас. Процедуры для лица и тела, поддерживающие красоту и здоровье. Забронируйте время уже сегодня.',
    privacyDescription:
      'Ознакомьтесь с нашей политикой конфиденциальности, чтобы получить четкое представление о сборе, использовании и защите персональных данных. Узнать больше.',
    bookDescription:
      'Забронируйте оздоровительную процедуру Fire and Ice в удобное для вас время. Выберите услугу и время, чтобы насладиться велнесом новой эры. Мы ждем вас!',
    termsDescription:
      'Условия использования Fire and Ice разъясняют правила пользования услугами, права и обязанности пользователя. Рекомендуем ознакомиться с условиями перед бронированием.',
    pricingDescription:
      'Посмотрите прайс-лист Fire and Ice и варианты пакетов. Найдите подходящее решение и забронируйте сеанс с комфортом.',
    promotionsDescription:
      'Ознакомьтесь со специальными предложениями и кампаниями Fire and Ice. Воспользуйтесь возможностью попробовать оздоровительные процедуры по более выгодной цене и удобно забронируйте время.',
    contactDescription:
      'Найдите контактные данные и местоположение Fire and Ice. Если у вас есть вопросы об услугах или бронировании, свяжитесь с нами.',
    scienceStudiesDescription:
      'Наши услуги основаны на научных исследованиях и доказательных методах. Узнайте больше о том, как они помогают вам восстановиться и чувствовать себя лучше.',
    checkBalanceDescription:
      'Введите данные и сразу узнайте остаток на вашей подарочной карте Fire and Ice. Просто, быстро и удобно!',
    galleryDescription:
      'Просматривайте галерею наших велнес-впечатлений в Fire & Ice. Смотрите нашу сауну, холодную купель и услуги восстановления в Таллинне.',
    services: {
      'infrared-sauna':
        'Инфракрасная сауна помогает расслабиться, поддерживает восстановление и улучшает самочувствие. Насладитесь спокойной обстановкой и удобно забронируйте сеанс онлайн.',
      'compression-massage':
        'Компрессионный массаж улучшает кровообращение и поддерживает восстановление. Расслабьтесь, восстановитесь и забронируйте сеанс удобно онлайн.',
      'contrast-therapy':
        'Контрастная терапия сочетает воздействие холода и тепла, помогая телу восстановиться и улучшая самочувствие. Забронируйте сеанс удобно онлайн.',
      'celluma-facial-light-therapy':
        'LED-светотерапия Celluma для лица помогает улучшить текстуру кожи, уменьшить воспаление и поддержать выработку коллагена. Забронируйте сеанс.',
      'cryotherapy-full-body':
        'Криотерапия всего тела предлагает интенсивный опыт холода, который поддерживает восстановление и улучшает самочувствие. Забронируйте сеанс удобно онлайн.',
      'cold-plunge':
        'Холодная ванна предлагает освежающий опыт, который поддерживает восстановление и улучшает самочувствие. Испытайте воздействие холода и забронируйте сеанс с комфортом.',
      'red-light-therapy':
        'Терапия красным светом помогает телу восстановиться и повышает чувство благополучия. Возьмите паузу и забронируйте сеанс просто онлайн.',
    },
  },

  // Birthday Picker
  birthdayPicker: {
    selectYear: 'Выберите год',
    selectMonth: 'Выберите месяц',
    selectDay: 'Выберите день',
    placeholder: 'дд/мм/гггг',
  },
};
